import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/arrow-alt-circle-left': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M8 256c0-137 111-248 248-248s248 111 248 248-111 248-248 248-248-111-248-248zM456 256c0-110.5-89.5-200-200-200s-200 89.5-200 200 89.5 200 200 200 200-89.5 200-200zM384 236v40c0 6.6-5.4 12-12 12h-116v67c0 10.7-12.9 16-20.5 8.5l-99-99c-4.7-4.7-4.7-12.3 0-17l99-99c7.6-7.6 20.5-2.2 20.5 8.5v67h116c6.6 0 12 5.4 12 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/arrow-alt-circle-left.js
// module id = 1688
// module chunks = 0